// Moduł Oferty (web): strony, komponenty dla profilu klienta i kompozycji (CONVENTIONS §10).
// Import rejestruje zakładkę „Oferty” w profilu klienta (slot `setClientTab('offers', …)`).
import { setClientTab } from '../clients/slots';
import { ClientOffersTab } from './components/ClientOffersTab';

export { ClientOffersTab } from './components/ClientOffersTab';
export { NewOfferDialog } from './components/NewOfferDialog';
export { OfferContentView } from './components/OfferContentView';
export { OfferRow } from './components/OfferRow';
export { OfferRows } from './components/OfferRows';
export { SendOfferDialog } from './components/SendOfferDialog';
export { VersionCompare } from './components/VersionCompare';
export * from './offer-format';
export { OfferDetailPage } from './pages/OfferDetailPage';
export { OffersListPage } from './pages/OffersListPage';

setClientTab('offers', ClientOffersTab);
